module.exports = __webpack_public_path__ + "static/media/Avenir-Heavy.aea0197d.woff2";